// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.tree-block {
  height: 300px;
  overflow: auto;
}

.buttons {
  text-align: right;
}
.buttons p-button {
  margin-left: 8px;
}

.container {
  padding: 12px;
}

:host ::ng-deep .c-select_block {
  position: relative;
  left: 10px;
  width: 30%;
}

:host ::ng-deep .c-input_small {
  width: 50%;
}

:host ::ng-deep .my-tree {
  width: 100%;
  display: inline-block;
  position: relative;
}
:host ::ng-deep .my-tree .c-inputtext {
  width: 500px;
  /*background: url("magnifier.svg") no-repeat 460px 5px;*/
}

.ustas-button {
  padding: 6px 12px;
  line-height: 1.64286;
  transition: all, 0.33333s;
  border: 1px solid transparent;
  border: var(--ids-theme-inuit-forms-border_outer, 1px solid transparent);
  border-radius: 3px;
  font-family: inherit;
  font-size: 14px;
  outline: 0;
  box-shadow: inset 0 0 0 1px transparent;
  box-shadow: var(--ids-theme-inuit-forms-border-inner, inset 0 0 0 1px transparent);
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.05);
  background-color: var(--ids-theme-inuit-forms-background, rgba(255, 255, 255, 0.05));
  color: #fff;
  color: var(--ids-theme-inuit-forms-color, #fff);
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(32, 33, 39, 0);
  -webkit-tap-highlight-color: rgba(var(--ids-theme-input-tap-highlight-color-rgb, 32, 33, 39), 0);
  -moz-appearance: none;
  margin: 5px;
}

.ustas-button::placeholder {
  color: rgba(255, 255, 255, 0.6);
  color: rgba(var(--ids-theme-inuit-forms-color-rgb, 255, 255, 255), 0.6);
}

.ustas-button:hover {
  border-color: #78f4ff;
  border-color: var(--ids-theme-primary-rgb, #78f4ff);
}

.ustas-button:focus {
  border-color: #78f4ff;
  border-color: var(--ids-theme-inuit-forms-border_outer_focused, #78f4ff);
  box-shadow: 0 0 7px 0px #78f4ff;
  box-shadow: var(--ids-theme-inuit-forms-border_inner_focused, 0 0 7px 0px #78f4ff);
  outline: 1px;
}

.ustas-button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.ustas-button span:after {
  content: "»";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -10px;
  transition: 0.5s;
}

.ustas-button:hover span {
  padding-right: 10px;
}

.ustas-button:hover span:after {
  opacity: 1;
  right: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
